/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../icons/Icons';
import ScreenReaderTip from '../ScreenReaderTip';
import announce from '../../../helpers/announce';

export default class SortableTableColumnHeader extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string,
        id: PropTypes.string,
        isSorted: PropTypes.bool,
        isAsc: PropTypes.bool,
        onSortToggle: PropTypes.func,
        isDisabled: PropTypes.bool
    };

    static defaultProps = {
        name: "",
        id: '',
        isSorted: false,
        isAsc: null,
        isDisabled: false
    };

    state = {
        isSorted: this.props.isSorted,
        isAsc: this.props.isAsc
    };

    componentDidUpdate(nextProps) {
        if (nextProps.isSorted !== this.state.isSorted) {
            this.setState({
                isSorted: nextProps.isSorted
            });
        }
        if (nextProps.isAsc !== this.state.isAsc) {
            this.setState({
                isAsc: nextProps.isAsc
            });
        }
    }

    onSortToggle = () => {
        const isAsc = !this.state.isAsc;

        announce(`Sorted by ${this.props.name}: ${isAsc ? "ascending" : "descending"}`);

        if (this.state.isSorted) {
            this.setState({
                isAsc
            }, () => {
                this.props.onSortToggle(this.state.isSorted, this.state.isAsc, this.props.id);
            });
        }
        else {
            this.setState({
                isSorted: true,
                isAsc: true
            }, () => {
                this.props.onSortToggle(this.state.isSorted, this.state.isAsc, this.props.id);
            });
        }
    }

    render() {
        const { name, isDisabled } = this.props;
        const { isSorted, isAsc } = this.state;

        let sortArrows = null;

        if (this.state.isSorted) {
            if (this.state.isAsc) {
                sortArrows = (
                    <div className="sort">
                        <div className="disabled">
                            <Icons.IconArrowUp alt="" />
                        </div>
                        <div className="sorted">
                            <Icons.IconArrowDown alt="" />
                        </div>
                    </div>
                );
            }
            else {
                sortArrows = (
                    <div className="sort">
                        <div className="sorted">
                            <Icons.IconArrowUp alt="" />
                        </div>
                        <div className="disabled">
                            <Icons.IconArrowDown alt="" />
                        </div>
                    </div>
                );
            }
        }
        else {
            sortArrows = (
                <div className="sort">
                    <div className="enabled">
                        <Icons.IconArrowUp alt="" />
                    </div>
                    <div className="enabled">
                        <Icons.IconArrowDown alt="" />
                    </div>
                </div>
            );
        }

        let sort = null;
        if (isSorted) {
            sort = isAsc ? "ascending" : "descending";
        }

        return (
            <th className="sortable-column-header" aria-sort={sort} role="columnheader">
                <ScreenReaderTip content="Click to sort the table by this column">
                    <button onClick={this.onSortToggle} disabled={isDisabled} >
                        <span className="title">
                            {name}
                        </span>
                        {sortArrows}
                    </button>
                </ScreenReaderTip>
            </th>
        );
    }
}